import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { userEdit, userView } from '../../redux/actions/userAction';
import { useNavigate, useParams } from 'react-router-dom';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import errorToast from '../../components/toast/errorToast';
import successToast from '../../components/toast/successToast';
import Loading from '../../components/ui/loader/loader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import './users.css';

const EditUser = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState({});

    const onSuccess = (data) => {
        setUserData(data.data.data);
        setLoading(false);
    };

    const onError = (data) => {
        errorToast(data.data.message);
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        dispatch(userView(id, onSuccess, onError));
    }, [id, dispatch]);

    const initialValues = {
        id: userData?.id || id,
        email: userData?.email || '',
        page_limit: userData?.page_limit || 0,
        sign_in: userData?.sign_in || '',
        is_admin: userData?.is_admin || false,
    };

    const validationSchema = Yup.object({
        email: Yup.string().email('Invalid email format').required('Email is required'),
        page_limit: Yup.string().required('Required'),
        sign_in: Yup.string().required('Required'),
    });

    const onSubmit = (values) => {
        setLoading(true);
        dispatch(userEdit(values, onEditSuccess, onError));
    };

    const onEditSuccess = (data) => {
        // setLoading(false);
        // navigate('/users');
        dispatch(userView(id, onSuccess, onError));
        successToast(data?.data?.message);
    };

    return (
        <div className="w-100 d-flex flex-column" style={{ height: "100%" }}>

            {/* ── Header ─────────────────────────────────────────────── */}
            <div
                className="d-flex align-items-center border-bottom px-3 position-sticky top-0 bg-white"
                style={{ height: 53, flexShrink: 0 }}
            >
                <AiOutlineArrowLeft
                    className="cursor_pointer me-2"
                    style={{ color: "#4A81E0", fontSize: 20 }}
                    onClick={() => navigate(-1)}
                />
                <span className="fs_18 fw_500">Edit User</span>
            </div>

            {/* ── Content ────────────────────────────────────────────── */}
            <div style={{ overflowY: "auto", flex: 1 }}>
                {loading ? (
                    <Loading text="Loading..." />
                ) : (
                    <div className="p-3 p-md-4 text-start" style={{ maxWidth: 560 }}>
                        <h6 className="fw_600 fs_20 mb-4">User Details</h6>
                        <div className="card" style={{ overflow: "hidden" }}>
                            <div className="card-body p-4">
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={onSubmit}
                                    enableReinitialize
                                >
                                    {({ values, handleChange, handleBlur }) => (
                                        <Form>
                                            <div className="mb-4">
                                                <label htmlFor="email" className="form-label fw_600 fs_14">Email</label>
                                                <Field
                                                    name="email"
                                                    type="email"
                                                    placeholder="Enter email"
                                                    className="form-control"
                                                    value={values.email}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={true}
                                                />
                                                <ErrorMessage name="email" component="div" className="text-danger mt-1 fs_12" />
                                            </div>

                                            <div className="mb-4">
                                                <label htmlFor="page_limit" className="form-label fw_600 fs_14">Page Limit</label>
                                                <Field
                                                    name="page_limit"
                                                    type="number"
                                                    placeholder="Enter page limit"
                                                    className="form-control"
                                                    value={values.page_limit}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <ErrorMessage name="page_limit" component="div" className="text-danger mt-1 fs_12" />
                                            </div>

                                            <div className="mb-4">
                                                <label htmlFor="sign_in" className="form-label fw_600 fs_14">Sign In Method</label>
                                                <Field
                                                    as="select"
                                                    name="sign_in"
                                                    className="form-select"
                                                    value={values.sign_in}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                >
                                                    <option value="">Select sign in method</option>
                                                    <option value="email">Email</option>
                                                    <option value="google">Google</option>
                                                </Field>
                                                <ErrorMessage name="sign_in" component="div" className="text-danger mt-1 fs_12" />
                                            </div>

                                            <div className="mb-4">
                                                <label htmlFor="is_admin" className="form-label fw_600 fs_14">User Type</label>
                                                <Field
                                                    as="select"
                                                    name="is_admin"
                                                    className="form-select"
                                                    value={values.is_admin}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                >
                                                    <option value="">Select user type</option>
                                                    <option value={true}>Admin</option>
                                                    <option value={false}>User</option>
                                                </Field>
                                                <ErrorMessage name="is_admin" component="div" className="text-danger mt-1 fs_12" />
                                            </div>

                                            <div className="d-flex gap-2 pt-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary px-4"
                                                    onClick={() => navigate(-1)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary px-4"
                                                >
                                                    Save Changes
                                                </button>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EditUser;
